
















































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { ModalState, PaymentMethod, PaymentMethodPayload } from '@/models'

import SwitchListItem from './SwitchListItem.vue'

@Component({
  components: {
    ListItem,
    SwitchListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class BindPaymentMethodModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: Array, required: true })
  readonly paymentMethods!: PaymentMethod[]

  isValid = false

  paymentMethod = 0
  isPublic = true

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  cancel () {
    this.modalState.reset()

    this.paymentMethod = 0

    this.$emit('cancel')
  }

  submit () {
    if (!this.isValid) {
      return
    }

    const payload: PaymentMethodPayload = {
      id: this.paymentMethod,
      public: this.isPublic
    }

    this.$emit('submit', payload)
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
